import React, { PropsWithChildren } from "react";
//#region redux
import { useDispatch } from "react-redux";
import { loginAsync, logout } from "store/actions/authActions";
//#endregion
//#region types
import { AuthEnums } from "models/enums";
//#endregion
//#region components
import Login from "./login";
import LoginContextProvider from "./context/contextProvider";
import { useSearchParams } from "react-router-dom";
//#endregion
import { UtilsHelper } from "utils/helpers";

const LoginContainer: React.FC<PropsWithChildren> = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const dispatch = useDispatch();

  const loginWithTicket = async (ticket: string) => {
    await dispatch(logout());
    await dispatch(loginAsync(`TICKET_LOGIN_${UtilsHelper.getUniqueId()}`, ticket, AuthEnums.LoginMethod.TICKET));
  };

  const ticket = searchParams.get("ticket");
  if (ticket) {
    searchParams.delete("ticket");
    setSearchParams(searchParams);
    loginWithTicket(ticket);
  }

  return (
    <LoginContextProvider>
      <Login />
    </LoginContextProvider>
  );
};

export default LoginContainer;
